<template>
  <div class="box">
    <top-header></top-header>
    <div class="content">
      <left-side></left-side>
      <div class="right">
        <div class="content-box">
          <div class="info">
            <div class="shade">
              <img :src="bannerBg" class="shade-img" alt="banner" />
            </div>
            <div class="title-wrap">
              <p class="title">
                <em class="title-ico"></em>{{ letter.newVipTitle }}
              </p>
            </div>
            <div class="info-detail">
              <div
                class="info-detail-left"
                v-if="isLogin"
                :class="{ flexcenter: isInWebview }"
              >
                <div class="role-info">
                  <div class="role-info-wrap">
                    {{ loginAccount }}
                  </div>
                  <div
                    class="role-info-switch"
                    @click="handleGoLogOut"
                    v-if="!isInWebview"
                  >
                    <em class="switch-ico"></em>{{ letter.logout }}
                  </div>
                </div>
                <p class="progress-tip one">
                  {{ letter.newVipNowPoint }}
                  {{ this.isUidLogin ? '***' : vipSumPoint }}
                </p>
                <div class="progress">
                  <div
                    class="progress-percentage"
                    :style="{ width: nextLevelPercentage }"
                  ></div>
                </div>
                <p class="progress-tip" v-if="vipLevel < vipLevelTotal">
                  {{
                    letter.newVipNextLevel.replace('${point}', nextLevelPoint)
                  }}
                </p>
              </div>
              <div class="info-detail-left" v-else>
                <div class="role-info-switch login" @click="showLoginPopup">
                  <em class="switch-ico"></em>{{ letter.newVipLogin }}
                </div>
              </div>
              <div class="info-detail-right">
                <div class="vip-level">V{{ vipLevel }}</div>
                <div class="btn" @click="backToHome">
                  {{
                    vipLevel < vipLevelTotal && isLogin
                      ? letter.newVipUpgrade
                      : letter.coinTypeName
                  }}
                </div>
              </div>
            </div>
            <back-home class="back"></back-home>
          </div>
          <div class="vip-detail">
            <p class="vip-detail-title">{{ letter.newVipLevel }}</p>
            <div class="btn-wrap">
              <div
                v-if="isLogin"
                href="javascript:;"
                class="coupon-btn btn j-click-vip-my-coupon"
                @click="refreshGameCoupon"
              >
                {{ letter.couponMyQuan }}
              </div>
            </div>
            <p class="vip-detail-tips">
              {{ letter.newVipTip }}
            </p>
            <div
              class="vip-detail-level-info swiper-container vip-swiper-container"
            >
              <div class="swiper-wrapper">
                <div
                  class="swiper-slide vip-slide"
                  v-for="item of vipLevelTotal"
                  :key="item"
                >
                  <div class="vip-title" :class="{ active: item <= vipLevel }">
                    VIP {{ item }}
                  </div>
                  <p class="vip-point">
                    ({{ letter.newVipReachPoint
                    }}{{ tableList[item - 1].reachPoint }})
                  </p>
                  <div class="vip-reward">
                    <div
                      class="vip-reward-item"
                      v-for="(rewardItem, index) in tableList[item - 1].reward"
                      :key="item + '-' + index"
                    >
                      <div class="ico-wrap">
                        <img :src="rewardItem.ico" class="ico" alt="ico" />
                        <div class="tag" v-if="rewardItem.tag">
                          {{ letter[rewardItem.tag] }}
                        </div>
                      </div>
                      <p class="desc">
                        {{ rewardItem.text }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="vip-swiper-pagination swiper-pagination"></div>
            </div>
            <div class="vip-detail-level-info pc">
              <div
                class="vip-slide"
                v-for="item of vipLevelTotal"
                :key="item"
                :haha="item"
              >
                <div class="vip-title" :class="{ active: item <= vipLevel }">
                  VIP {{ item }}
                </div>
                <p class="vip-point">
                  ({{ letter.newVipReachPoint
                  }}{{ tableList[item - 1].reachPoint }})
                </p>
                <div class="vip-reward">
                  <div
                    class="vip-reward-item"
                    v-for="(rewardItem, index) in tableList[item - 1].reward"
                    :key="item + '-' + index"
                    :haha="item + '-' + index"
                  >
                    <div class="ico-wrap">
                      <img :src="rewardItem.ico" class="ico" alt="ico" />
                      <div class="tag" v-if="rewardItem.tag">
                        {{ letter[rewardItem.tag] }}
                      </div>
                    </div>
                    <p class="desc">
                      {{ rewardItem.text }}
                    </p>
                  </div>
                </div>
                <div class="suo" v-show="item > vipLevel"></div>
              </div>
            </div>
            <div class="rule-content">
              <template v-if="isShowPreRightsPopup">
                <p>{{ letter.notice }}</p>
                <p v-html="rightsIntro"></p>
              </template>
              <template v-else>
                <p>{{ letter.newVipRuleInfo }}</p>
                <p
                  class="part-1 text"
                  v-for="(item, index) in ruleConfig.ruleNum"
                  :key="index"
                >
                  {{
                    letter[gamePrefix + 'VipRule' + item].replaceAll(
                      '${gameName}',
                      gameName
                    )
                  }}
                </p>
              </template>
              <p class="part3 text"></p>
              <div
                class="ratio-btn btn"
                v-if="isOnlineRightsCenter"
                @click="jumpRightLink"
              >
                {{ letter.goToRights }}
              </div>
              <div
                class="ratio-btn btn j-click-vip-ratio"
                v-if="visibleCouponRatio"
                @click="jumpLink"
              >
                {{ letter.couponRatio }}
              </div>
              <div
                class="ratio-btn btn j-click-vip-coupon-limit-ratio"
                v-if="couponTopLimitLink"
                @click="jumpCouponTopLimitLink"
              >
                {{ letter.couponTopLimit }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <transition name="fade" mode="out-in">
      <coupon-list-popup
        v-if="isShowGameCouponPopup"
        popupType="game"
        :enableCouponList="gameCouponEnableList"
        :disableCouponList="gameCouponDisableList"
        :expireCouponList="gameCouponExpireList"
        :activeId="gameActiveCouponId"
        :showItemUseBtn="false"
        @closeCouponPopup="hideGameCouponPopup"
        :isPopup="true"
      ></coupon-list-popup>
    </transition>
    <transition name="fade" mode="out-in">
      <login-popup v-if="isLoginPopup"></login-popup>
    </transition>
  </div>
</template>

<script>
import TopHeader from '@components/officialWebStore/TopHeader.vue';
import coupon from '@mixins/officialWebStore/coupon';
import LeftSide from '@components/officialWebStore/LeftSide.vue';
import BackHome from '@components/officialWebStore/BackHome.vue';
import CouponListPopup from '@components/officialWebStore/coupon/CouponListPopup.vue';
import LoginPopup from '@components/officialWebStore/login/LoginPopup.vue';
import Swiper from 'swiper';
import login from '@mixins/officialWebStore/login';
import { JUDGE_IS_LOGIN } from '@store/officialWebStore/login';
import { locationType, clickButton } from '@plugins/biPoint/_configWebstoreV2';
import { sdkOpenLink } from '@utiles/officialStore/sdkCtrl';
import openActivity, { NOTICE_POPUP_ACTIVITY } from '@utiles/openActivity';
import { getGlobalGetLinkParams } from '@utiles/globalGetLink';
import { mapGetters } from 'vuex';
export default {
  name: 'VipPage',
  mixins: [coupon, login],
  data() {
    return {
      swiper: null
    };
  },
  created() {
    this.$store.dispatch(JUDGE_IS_LOGIN);
    this.loadGameCouponList();
    this.loadVipCouponInfo();
  },
  activated() {
    this.$nextTick(() => {
      this.slideToNowLevel();
    });
  },
  mounted() {
    this.$nextTick(() => {
      this.initSwiper();
    });
  },
  watch: {
    vipLevel: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.slideToNowLevel();
        }
      }
    }
  },
  computed: {
    gameId() {
      return this.$store.state.gameId;
    },
    lang() {
      return this.$store.state.lang;
    },
    letter() {
      return this.$store.state.letter;
    },
    loginAccount() {
      return this.$store.state.login.loginAccount;
    },
    isUidLogin() {
      return this.$store.state.login.isUidLogin;
    },
    gamePrefix() {
      return this.ruleConfig.gamePrefix || '';
    },
    ruleConfig() {
      return this.$store.getters.gameInfoConfig.vipRuleConfig;
    },
    isOnlineRightsCenter() {
      return this.$store.getters.gameInfoConfig?.isOnlineRightsCenter || false;
    },
    gameName() {
      if (+this.gameId === 303) {
        if (this.lang === 'ko-KR') {
          return '검의꽃M';
        }
        if (this.lang === 'th-TH') {
          return 'ตำนานแห่งเซียน';
        }
      }
      return this.ruleConfig.gameName;
    },
    nextLevelPercentage() {
      if (this.vipLevel < this.vipLevelTotal) {
        return (this.vipSumPoint / this.vipNextLevelPoint) * 100 + '%';
      }
      return '100%';
    },
    nextLevelPoint() {
      return this.vipNextLevelPoint - this.vipSumPoint;
    },
    nextLevelNeed() {
      return this.letter.nextLevelNeed
        .replace(
          '${num}',
          this.isUidLogin ? '***' : this.vipNextLevelPoint - this.vipSumPoint
        )
        .replace('${level}', this.isUidLogin ? '***' : +this.vipLevel + 1);
    },
    vipLevelTotal() {
      return this.ruleConfig?.table?.length > 0
        ? this.ruleConfig.table.length
        : 0;
    },
    tableList() {
      if (!this.ruleConfig.table) {
        return [];
      }
      try {
        let newTableList = JSON.parse(JSON.stringify(this.ruleConfig.table));
        const reg = /\$\{(.+?)\}/;
        const reg_g = /\$\{(.+?)\}/g;
        newTableList.forEach(item => {
          if (item?.reward && item.reward.length > 0) {
            item.reward.forEach(rItem => {
              let newletter = rItem.text.toString().match(reg);
              rItem.text = rItem.text.replaceAll(
                rItem.text.toString().match(reg_g),
                this.letter[newletter[1]]
              );
            });
          }
        });
        return newTableList;
      } catch (error) {
        console.log(error);
      }
    },
    couponTopLimitLink() {
      return this.ruleConfig.couponTopLimitLink;
    },
    visibleCouponRatio() {
      // 日本平台不展示VIP积分比例跳转按钮
      return !this.$store.getters.isJpPlatform;
    },
    bannerBg() {
      return this.ruleConfig?.bannerBg || '';
    },
    isInWebview() {
      return this.$store.state.isInWebview;
    },
    isShowPreRightsPopup() {
      return this.gameInfoConfig?.isShowPreRightsPopup;
    },
    rightsIntro() {
      return (
        this.letter.preRightsIntro.replace(
          '${offLineDate}',
          this.gameInfoConfig?.offLineDate[this.lang] ||
            this.gameInfoConfig?.offLineDate['en-US'] ||
            ''
        ) || ''
      );
    },
    ...mapGetters(['gameInfoConfig'])
  },
  methods: {
    handleGoLogOut() {
      clickButton({
        btnName: 'logout',
        locationKey: locationType.vipPage
      });
      this.goLogOut();
    },
    jumpRightLink() {
      clickButton({
        btnName: 'go_right_center',
        locationKey: this.$route.meta.pageName,
        otherParams: {
          link: this.gameInfoConfig?.rightsCenterLink,
          name: 'rightCenterPage'
        }
      });
      openActivity(NOTICE_POPUP_ACTIVITY, this.gameInfoConfig?.rightsCenterLink, {
          language: this.lang,
          appLanguage: this.lang,
          ...getGlobalGetLinkParams()
        });
    },
    jumpLink() {
      sdkOpenLink({
        link: this.ruleConfig.link
      });
    },
    jumpCouponTopLimitLink() {
      sdkOpenLink({
        link: this.couponTopLimitLink
      });
    },
    backToHome() {
      clickButton({
        btnName: 'top_up',
        locationKey: locationType.vipPage
      });
      this.$router.push({
        name: 'home'
      });
    },
    initSwiper() {
      try {
        this.swiper = new Swiper('.vip-swiper-container', {
          slidesPerView: 'auto',
          spaceBetween: 10,
          centeredSlides: true,
          pagination: {
            el: '.vip-swiper-pagination',
            type: 'progressbar'
          }
        });
      } catch (e) {
        console.log(e);
      }
    },
    slideToNowLevel() {
      if (this.swiper && this.vipLevel) {
        this.swiper.slideTo(this.vipLevel - 1, 1000, false);
      }
    }
  },
  components: {
    TopHeader,
    LeftSide,
    BackHome,
    CouponListPopup,
    LoginPopup
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialWebStore/officialWebStore.scss';
.bg {
  display: block;
  float: left;
  position: relative;
  width: 100%;
  height: auto;
  min-height: 100%;
  background-color: #fff;
  text-align: center;
  color: #333;
}
.content {
  position: relative;
}

.content-box {
  position: relative;
  box-sizing: border-box;
  margin: 0 auto;
  padding: 0 20px;
  max-width: 1200px;
  font-size: 0;
  color: #333;

  .rule-content {
    box-sizing: border-box;
    margin: 30px auto;
    color: #666;
    font-size: 22px;
    p {
      line-height: 50px;
      text-align: left;
      font-size: 24px;
    }
    .mt {
      margin-top: 50px;
    }
  }

  .vip-desc-table {
    border-collapse: collapse;
    border-spacing: 0;
    margin: 10px * 2 auto 30px;
    width: 96%;
    th,
    td {
      border: 1px solid #666;
      height: 41px;
      line-height: 41px;
      text-align: center;
      font-size: 20px;
      color: #666;
      white-space: pre-wrap;
    }
  }
}

.info {
  position: relative;
  width: 709px;
  height: 282px;
  margin: 15px auto;
  border-radius: 9px;
  background-color: transparent;
  .shade {
    position: absolute;
    left: 0;
    top: 0;
    .shade-img {
      width: 100%;
      height: 100%;
      border-radius: 9px;
    }
  }
  .title-wrap {
    position: relative;
    text-align: center;
    width: 100%;
    margin: 0 auto 35px;
    font-size: 28px;
    color: #ffcb8f;
    padding-top: 30px;
    .title {
      margin-top: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 20px;
      color: #ffcb8f;
      font-size: 28px;
      &-ico {
        display: inline-block;
        width: 29px;
        height: 27px;
        background: url($tmslgImg + 'title-ico.png') no-repeat;
        margin-right: 20px;
      }
    }
    .sub-title {
      font-size: 20px;
    }
  }
  .info-detail {
    position: relative;
    box-sizing: border-box;
    padding: 30px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    width: 670px;
    background-image: linear-gradient(to bottom right, #ffcc90, #ffffff);
    border-radius: 9px;
    &-left {
      position: relative;
      width: 303px;
      &.flexcenter {
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
      .role-info {
        &-wrap {
          font-size: 22px;
          color: #333333;
          .account {
            margin-bottom: 10px;
          }
        }
        &-switch {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 44px;
          padding: 0 20px;
          box-sizing: border-box;
          font-size: 22px;
          color: #333333;
          background-color: #fff;
          border-radius: 40px;
          margin-top: 30px;
          width: fit-content;
          .switch-ico {
            display: inline-block;
            width: 30px;
            height: 27px;
            background: url($tmslgImg + 'switch-char.png') no-repeat;
            margin-right: 10px;
          }
          &.login {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            margin-top: 0;
          }
        }
      }
      .progress {
        width: 303px;
        height: 15px;
        background-color: #333333;
        border-radius: 8px;
        margin: 15px 0 15px;
        .progress-percentage {
          width: 0;
          height: 15px;
          background-color: #ffcc90;
          border-radius: 8px;
        }
      }
      .progress-tip {
        font-size: 20px;
        color: #333333;
        line-height: 19px;
        &.one {
          margin-top: 20px;
        }
      }
    }
    &-right {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .vip-level {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 36px;
        font-weight: bold;
        color: #333333;
        width: 177px;
        height: 177px;
        background: url($tmslgImg + 'level-bg.png') no-repeat;
      }
      .btn {
        font-size: 22px;
        text-align: center;
        line-height: 44px;
        height: 44px;
        background-color: #ffcc90;
        border-radius: 40px;
        padding: 0 20px;
        box-sizing: border-box;
      }
    }
  }
}
.vip-detail {
  padding: 32px 20px;
  background-color: #ffffff;
  border-radius: 9px;
  margin-top: 180px;
  box-sizing: border-box;
  &-title {
    text-align: center;
    font-size: 26px;
    color: #333333;
    font-weight: bold;
  }

  &-tips {
    font-size: 20px;
    color: #666666;
    text-align: center;
  }
}
.ratio-btn {
  margin-bottom: 16px;
}
.btn-wrap {
  display: flex;
  justify-content: space-evenly;
  margin: 30px auto;
}
.btn {
  height: 44px;
  line-height: 44px;
  background-color: #ffcc90;
  border-radius: 40px;
  padding: 0 20px;
  text-align: center;
  font-size: 22px;
  color: #333;
}
.back {
  position: absolute;
  left: 20px;
  top: 30px;
  font-size: 0;
  color: #ffcb8f !important;
  margin: 0;
  ::v-deep .back-ico {
    width: 17px;
    height: 28px;
    background: url($tmslgImg + 'vip-back.png') no-repeat;
  }
}
.vip-detail-level-info {
  position: relative;
  width: 670px;
  height: 620px;
  margin-top: 60px;
  &.pc {
    display: none;
  }
}
.swiper-slide {
  transform: scale(0.8);
  transition: 300ms;
}
.swiper-slide-active {
  transform: scale(1);
}
.vip-slide {
  position: relative;
  width: 390px;
  height: 525px;
  background-color: #fff5ea;
  box-shadow: 0px 10px 10px 0px #e7e7e7;
  border-radius: 9px;
  border: solid 3px #ffe3c4;
  .vip-title {
    position: relative;
    margin: 0 auto;
    color: #8c8c8c;
    font-size: 40px;
    width: 276px;
    height: 78px;
    background: url($tmslgImg + 'vip-level-bg-unget.png') no-repeat;
    text-align: center;
    line-height: 78px;
    font-weight: bold;
    &.active {
      color: #5f4224;
      background: url($tmslgImg + 'vip-level-bg-get.png') no-repeat;
    }
  }
  .vip-point {
    padding: 0 26px;
    width: 100%;
    text-align: center;
    font-size: 23px;
    color: #333;
    box-sizing: border-box;
    margin: 10px auto;
  }
  .vip-reward {
    width: 100%;
    padding: 0 26px;
    height: 370px;
    overflow: -moz-scrollbars-none;
    overflow-y: scroll;
    box-sizing: border-box;
    -ms-overflow-style: none;
    scrollbar-width: none;
    padding-top: 20px;
    &::-webkit-scrollbar {
      display: none;
      width: 0 !important;
    }
    margin: 0 auto 34px;
    overflow-x: hidden;

    .vip-reward-item {
      display: flex;
      align-items: center;
      margin-bottom: 28px;
      .ico-wrap {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 80px;
        height: 80px;
        background-color: #ffe3c4;
        border-radius: 16px;
        flex-shrink: 0;
        .ico {
          width: 61px;
        }
        .tag {
          position: absolute;
          left: -8px;
          top: -14px;
          border-radius: 5px;
          color: #fff;
          padding: 0 8px;
          font-size: 16px;
          height: 23px;
          line-height: 23px;
          text-align: center;
          background: #f3773b;
          white-space: nowrap;
          &::before {
            content: '';
            position: absolute;
            width: 8px;
            height: 18px;
            bottom: -4px;
            left: 0;
            background: #f3783b;
            border-radius: 100% 0 0 100% / 40%;
          }
        }
      }
      .desc {
        font-size: 23px;
        color: #333333;
        margin-left: 26px;
        line-height: 26px;
      }
    }
  }
}

.vip-swiper-pagination {
  position: absolute;
  top: 585px;
  width: 381px;
  height: 15px;
  background-color: #333333;
  border-radius: 8px;
  left: 50%;
  transform: translateX(-50%);
}

@media screen and (orientation: landscape) {
  .content {
    display: flex;
    justify-content: space-between;
    width: 1300px;
    margin: 21px auto;

    .right {
      width: 898px;
      .banner {
        display: none;
      }
      .content-box {
        padding: 0;
      }
      .info {
        position: relative;
        width: 899px;
        height: 357px;
        margin: 0 auto 30px;
        .shade {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
        }
        .title-wrap {
          margin: 0 auto 27px;
          font-size: 22px;
          padding-top: 65px;
          .title {
            margin-bottom: 26px;
            font-size: 22px;
          }
          .sub-title {
            font-size: 16px;
          }
        }
        .info-detail {
          width: 859px;
          &-left {
            width: 386px;
            .role-info {
              display: flex;
              align-items: center;
              justify-content: space-between;
              &-wrap {
                font-size: 16px;
              }
              &-switch {
                font-size: 16px;
                margin-top: 0;
                cursor: pointer;
                &:hover {
                  color: #000;
                  background: #ffcc90;
                }
                .switch-ico {
                  width: 20px;
                  height: 18px;
                  background-size: cover;
                }
                &.login {
                  position: absolute;
                  top: 50%;
                  transform: translateY(-50%);
                  margin-top: 0;
                }
              }
            }
            .progress {
              width: 386px;
              margin: 20px 0 20px;
            }
            .progress-tip {
              font-size: 16px;
            }
          }
          &-right {
            align-items: center;
            .vip-level {
              font-size: 28px;
              width: 109px;
              height: 109px;
              background-size: cover;
            }
            .btn {
              font-size: 16px;
              cursor: pointer;
              &:hover {
                color: #ffcc90;
                background: #000;
              }
            }
          }
        }
      }
      .back {
        font-size: 16px;
        top: 23px;
        left: 30px;
        cursor: pointer;
        ::v-deep .back-ico {
          width: 9px;
          height: 16px;
          background-size: cover;
        }
      }
      .vip-detail {
        margin-top: 0;
        .vip-detail-title {
          font-size: 22px;
        }
        .btn {
          cursor: pointer;
          &:hover {
            color: #ffcc90;
            background: #000;
          }
        }
        .btn,
        .vip-detail-tips {
          font-size: 16px;
        }
        .rule-content p {
          font-size: 16px;
        }
        .vip-desc-table {
          th,
          td {
            font-size: 16px;
          }
        }
      }
      .vip-swiper-container {
        display: none !important;
      }
      .vip-detail-level-info {
        width: 860px;
        height: 759px;
        display: grid;
        margin-top: 30px;
        /*  声明列的宽度  */
        grid-template-columns: repeat(3, 270px);
        /*  声明行间距和列间距  */
        grid-row-gap: 30px;
        grid-column-gap: 25px;
        /*  声明行的高度  */
        grid-template-rows: 364px;
        &.pc {
          display: grid;
        }
        .vip-slide {
          position: relative;
          width: 270px;
          height: 364px;
          .vip-title {
            font-size: 28px;
            width: 191px;
            height: 54px;
            line-height: 54px;
            background-size: cover;
          }
          .vip-point {
            font-size: 16px;
          }
          .vip-reward {
            padding: 0 18px;
            margin-top: 13px;
            height: 258px;
          }
          .vip-reward-item {
            .ico-wrap {
              width: 56px;
              height: 56px;
              .ico {
                width: 42px;
              }
            }
            .desc {
              font-size: 16px;
              line-height: 19px;
            }
          }
          .suo {
            position: absolute;
            right: 12px;
            bottom: 12px;
            width: 63px;
            height: 63px;
            background: url($tmslgImg + 'suo.png') no-repeat;
          }
        }
      }
    }
  }
}

@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) {
  .content {
    widows: 1200px;
  }
}
</style>

<style lang="scss">
.swiper-pagination-progressbar {
  .swiper-pagination-progressbar-fill {
    background-color: #ffcc90;
    border-radius: 8px;
  }
}
</style>
